import { supabase } from '@/integrations/supabase/client';

export async function fetchUserFavorites(userId: string): Promise<string[]> {
  const { data, error } = await supabase
    .from('user_favorite_tools')
    .select('tool_id')
    .eq('user_id', userId)
    .order('created_at', { ascending: true });

  if (error) {
    console.error('Error fetching favorites:', error);
    return [];
  }

  return data?.map(row => row.tool_id) || [];
}

export async function addFavorite(userId: string, toolId: string): Promise<boolean> {
  const { error } = await supabase
    .from('user_favorite_tools')
    .insert({ user_id: userId, tool_id: toolId });

  if (error) {
    console.error('Error adding favorite:', error);
    return false;
  }

  return true;
}

export async function removeFavorite(userId: string, toolId: string): Promise<boolean> {
  const { error } = await supabase
    .from('user_favorite_tools')
    .delete()
    .eq('user_id', userId)
    .eq('tool_id', toolId);

  if (error) {
    console.error('Error removing favorite:', error);
    return false;
  }

  return true;
}

export async function toggleFavorite(
  userId: string,
  toolId: string,
  isFavorite: boolean
): Promise<boolean> {
  if (isFavorite) {
    return removeFavorite(userId, toolId);
  } else {
    return addFavorite(userId, toolId);
  }
}
